/** Premium positioning shared across every section (edition, access, support, contrast). */

export const PREMIUM = {
  edition: 'Build It · Price It · Sell It',
  editionShort: '2026 Edition',
  access: 'Free updates · Lifetime access',
  support: 'Personal email support',
  pages: '240 pages',
} as const

export const BONUS_LINE_SHORT = 'Plus 5 premium bonuses, included free.'

export const PREMIUM_SEALS: string[] = ['7-day guarantee', '2026 Edition', 'Lifetime access', 'Email support']

export interface ContrastRow {
  ours: string
  theirs: string
}

export const CONTRAST: ContrastRow[] = [
  { ours: '30 complete plans with exact cut lists in in + mm', theirs: 'A photo and a guess' },
  { ours: 'Small, fast pieces people actually buy', theirs: 'Big builds that sit unsold in the garage' },
  { ours: 'A build & sell card with steel cost, hours and your price', theirs: 'Guessing what to charge' },
  { ours: 'No plasma or CNC: chop saw, grinder, drill, welder', theirs: 'Plans that need a shop you don\'t have' },
]
